var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H1C0.45 16 0 15.55 0 15V1C0 0.45 0.45 0 1 0H13C13.55 0 14 0.45 14 1V15C14 15.55 13.55 16 13 16ZM17 4H19C19.55 4 20 3.55 20 3V1C20 0.45 19.55 0 19 0H17C16.45 0 16 0.45 16 1V3C16 3.55 16.45 4 17 4ZM17 16H19C19.55 16 20 15.55 20 15V13C20 12.45 19.55 12 19 12H17C16.45 12 16 12.45 16 13V15C16 15.55 16.45 16 17 16ZM17 10H19C19.55 10 20 9.55 20 9V7C20 6.45 19.55 6 19 6H17C16.45 6 16 6.45 16 7V9C16 9.55 16.45 10 17 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgGridIcon);
export default __webpack_public_path__ + "static/media/tg-grid-icon.fa292fb5f81cd7a26f9a65f0e5e14b74.svg";
export { ForwardRef as ReactComponent };